import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Spin } from 'antd';
import { EngagmentGrowth } from '../../store/Slices/EngagementSlice';
import { AnalyticseGrowth, GroupAnaylicts } from '../../store/Slices/AnalyticsSlice';
import { getEngagementData } from '../../services/group';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

export default function Engagementchart() {
    const [InstaImpression, setInstaImpression] = useState([]);
    const [FbImpressions, setFbImpressions] = useState([]);
    const [PintrestEng, setPintrestEng] = useState([]);
    const [isLoader, setIsloader] = useState(true);

    const Sinceselector = useSelector((state) => state.SinceDates);
    const { selectedGroup } = useSelector((state) => state.groups);
    const untilSelector = useSelector((state) => state.UntilDates);
    const Filter = useSelector((state) => state.Filter);
    const { analytics } = useSelector((state) => state.Analytics);
    const dispatch = useDispatch();

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false,
                }
            },
        },
        elements: {
            point: {
                radius: 0.5
            }
        },
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rectRounded',
                    padding: 30
                }
            }
        }
    };

    const data = {
        datasets: [
            {
                label: 'Instagram',
                data: InstaImpression,
                fill: true,
                borderColor: '#CE3665',
                backgroundColor: '#CE3665',
                borderWidth: 0.4,
                tension: 0.4
            },
            {
                label: 'Facebook',
                data: FbImpressions,
                fill: true,
                borderColor: '#6F5ED3',
                backgroundColor: '#6F5ED3',
                borderWidth: 0.4,
                tension: 0.3
            },
            {
                label: 'Pinterest',
                data: PintrestEng,
                fill: true,
                borderColor: '#3896E3',
                backgroundColor: '#3896E3',
                borderWidth: 1,
                tension: 0.3
            }
        ],
    };

    const FBEngeProcess = (newValues) => {
        const FBRAWData = newValues.flat(); 
        const FbnewObj = Object.values(
            FBRAWData.reduce((acc, { end_time, value }) => {
                acc[end_time] = acc[end_time] || { end_time, value: 0 };
                acc[end_time].value += Number(value);
                return acc;
            }, {})
        );

        setFbImpressions([
            {
                x: new Date(Sinceselector[0] * 1000).toISOString().split("T")[0].slice(5),
                y: 0,
            },
            ...FbnewObj.map(({ end_time, value }) => ({
                x: end_time.split("T")[0].slice(5),
                y: value,
            }))
        ]);
    };

    const PinEngagementProcess = (PinEngagement) => {
        const PinnewObj = Object.values(
            PinEngagement.reduce((acc, { date, metrics, data_status }) => {
                acc[date] = acc[date] || { end_time: date, value: 0 };
                acc[date].value += data_status === "READY" ? metrics.ENGAGEMENT : 0;
                return acc;
            }, {})
        );

        setPintrestEng(
            PinnewObj.map(({ end_time, value }) => ({
                x: end_time.slice(5),
                y: value,
            }))
        );
    };

    const InstagramEngagementProcess = (instaEngagement) => {
        const InstaObj = Object.values(
            instaEngagement.reduce((acc, { date, metrics, data_status }) => {
                acc[date] = acc[date] || { end_time: date, value: 0 };
                acc[date].value += data_status === "READY" ? metrics.ENGAGEMENT : 0;
                return acc;
            }, {})
        );

        setInstaImpression(
            InstaObj.map(({ end_time, value }) => ({
                x: end_time.slice(5),
                y: value,
            }))
        );
    };

    const GetEngagement = async () => {
        try {
            setIsloader(true);

            const analytics = await getEngagementData(Filter, Sinceselector, untilSelector, selectedGroup);
            dispatch(GroupAnaylicts(analytics));
            
            let FBEngagement = [];
            let PinEngagement = [];
            let InstaImpression = [];

            if (analytics.FACEBOOK?.length) {
                analytics.FACEBOOK?.forEach((elem) => {
                    elem.data.forEach((FBelem) => {
                        if (FBelem.name === "page_post_engagements") {
                            FBEngagement.push(FBelem.values);
                        }
                    });
                });
            }

            if (analytics.PINTEREST?.length) {
                analytics.PINTEREST?.forEach((elem) => {
                    elem.analytics.all.daily_metrics.forEach((data) => {
                        PinEngagement.push(data);
                    });
                });
            }

            if (analytics.INSTAGRAM?.length) {
                analytics.INSTAGRAM?.forEach((elem) => {
                    elem.data.values.forEach((data) => {
                        InstaImpression.push(data);
                    });
                });
            }

            if (FBEngagement.length) FBEngeProcess(FBEngagement);
            if (PinEngagement.length) PinEngagementProcess(PinEngagement);
            if (InstaImpression.length) InstagramEngagementProcess(InstaImpression);

            const EngagementGrow = data.datasets[1].data.reduce((acc, curr) => acc + curr.y, 0);
            dispatch(EngagmentGrowth(EngagementGrow));
            dispatch(AnalyticseGrowth(analytics));

        } catch (error) {
            console.error("Engagement data fetch failed:", error);
        } finally {
            setIsloader(false);
        }
    };

    useEffect(() => {
        if (Filter.length !== 0) {
            GetEngagement();
        }
    }, [Sinceselector, untilSelector, Filter, selectedGroup]);

    if (isLoader || !analytics) {
        return (
            <div className='d-flex align-items-center justify-content-center'>
                <Spin />
            </div>
        );
    }

    const totalEngagement = InstaImpression.reduce((acc, curr) => acc + curr.y, 0) +
                            FbImpressions.reduce((acc, curr) => acc + curr.y, 0) +
                            PintrestEng.reduce((acc, curr) => acc + curr.y, 0);

    return (
        <>
            <div className='chart_section'>
                <div className='chart_heading d-flex flex-column px-3 py-3'>
                    <label className='label_head'>
                        Engagement
                    </label>

                    <label className='label_sub_head'>
                        See how people are engaging with your posts during the reporting period.
                    </label>
                </div>

                <div style={{ height: '40vh' }}>
                    <Line options={options} data={data} />
                </div>

                <div className='w-100 px-3'>
                    <table className='w-100 table chart_table'>
                        <thead>
                            <tr>
                                <th>Engagement Metrics</th>
                                <th>Totals</th>
                                <th>% Change</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Total Engagement</td>
                                <td>{totalEngagement}</td>
                                <td>2.1%</td>
                            </tr>
                            <tr>
                                <td>Instagram Engagement</td>
                                <td>{InstaImpression.reduce((acc, curr) => acc + curr.y, 0)}</td>
                                <td>2400%</td>
                            </tr>
                            <tr>
                                <td>Facebook Engagement</td>
                                <td>{FbImpressions.reduce((acc, curr) => acc + curr.y, 0)}</td>
                                <td>2400%</td>
                            </tr>
                            <tr>
                                <td>Pinterest Engagement</td>
                                <td>{PintrestEng.reduce((acc, curr) => acc + curr.y, 0)}</td>
                                <td>2400%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}